function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.1993 108.292C27.4751 108.292 4.10634 84.9215 4.10634 56.1973C4.10634 27.4711 27.4751 4.1023 56.1993 4.1023C84.9235 4.1023 108.294 27.4711 108.294 56.1973C108.294 84.9215 84.9235 108.292 56.1993 108.292ZM56.1993 0C25.2131 0 0 25.2091 0 56.1973C0 87.1835 25.2131 112.393 56.1993 112.393C87.1856 112.393 112.397 87.1835 112.397 56.1973C112.397 25.2091 87.1856 0 56.1993 0Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.4032 38.7417H36.01V36.3465C36.01 35.2407 36.914 34.3387 38.0238 34.3387H76.3893C77.5012 34.3387 78.4032 35.2407 78.4032 36.3465V38.7417ZM72.1882 86.4801H42.225L39.6502 42.7613H74.7629L72.1882 86.4801ZM48.7427 29.2638C48.7427 27.4175 50.248 25.9142 52.0984 25.9142H62.3168C64.1672 25.9142 65.6725 27.4175 65.6725 29.2638V30.3191H48.7427V29.2638ZM76.3893 30.3191H69.7001V29.2638C69.7001 25.1998 66.3888 21.8926 62.3168 21.8926H52.0984C48.0243 21.8926 44.715 25.1998 44.715 29.2638V30.3191H38.0238C34.6944 30.3191 31.9844 33.0231 31.9844 36.3465V40.7515C31.9844 41.8633 32.8843 42.7613 33.9982 42.7613H35.6145L38.3184 88.609C38.379 89.6704 39.2628 90.4997 40.3282 90.4997H74.087C75.1544 90.4997 76.0342 89.6704 76.0967 88.609L78.7987 42.7613H80.417C81.5288 42.7613 82.4308 41.8633 82.4308 40.7515V36.3465C82.4288 33.0231 79.7188 30.3191 76.3893 30.3191Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.2083 82.023C58.1526 82.023 58.9194 81.2582 58.9194 80.3159V48.8272C58.9194 47.8869 58.1526 47.1201 57.2083 47.1201C56.2639 47.1201 55.4951 47.8869 55.4951 48.8272V80.3159C55.4951 81.2582 56.2639 82.023 57.2083 82.023Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.1907 82.023H65.2633C66.1815 82.023 66.9321 81.3067 66.9725 80.3885L68.3164 48.8999C68.3345 48.4438 68.1751 48.01 67.8644 47.673C67.5556 47.338 67.1339 47.1403 66.6779 47.1221C66.6536 47.1201 66.6294 47.1201 66.6052 47.1201C65.6952 47.1201 64.9344 47.8405 64.8961 48.7546L63.5522 80.2453C63.534 80.6993 63.6914 81.1351 63.9981 81.4701C64.3089 81.8071 64.7306 82.0028 65.1907 82.023Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.1503 82.023H49.2189C49.683 82.0028 50.1047 81.8071 50.4135 81.4721C50.7222 81.1372 50.8816 80.7013 50.8634 80.2453L49.5195 48.7546C49.5014 48.2985 49.3036 47.8788 48.9687 47.5701C48.6499 47.2775 48.2422 47.1201 47.8124 47.1201C47.7882 47.1201 47.764 47.1201 47.7378 47.1221C47.2797 47.1403 46.858 47.338 46.5513 47.673C46.2425 48.01 46.0811 48.4438 46.1013 48.8999L47.4432 80.3865C47.4835 81.3067 48.2322 82.023 49.1503 82.023Z"
});

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Delete_icon.d78620aa.svg";
export { ForwardRef as ReactComponent };